<header class="header header-custom header-fixed header-one">
    <div class="container">
        <nav class="navbar navbar-expand-lg header-nav">
            <div class="navbar-header">
                <a routerLink="/" class="navbar-brand logo">
                    <img src="assets/img/logo.svg" class="img-fluid logo-img" alt="Logo" />
                </a>
            </div>
            <ul class="main-nav ">
                <li class="login-link">
                    <a routerLink="/auth/login">{{'ADMIN.BUTTONS.LOGIN-SIGNUP' | translate }}</a>
                </li>
            </ul>
            <ul class="nav header-navbar-rht " *ngIf="!user">
                <li class="register-btn">
<!--                    <a routerLink="/auth/register-doctor" class="btn reg-btn">-->
<!--                        <i class="feather icon-user"></i>{{'ADMIN.AUTH.HEADER.AUTH-DOCTOR' | translate }}-->
<!--                    </a>-->
                    <a routerLink="/auth/register-doctor" class="btn reg-btn">
                        <i class="feather icon-user"></i>{{'ADMIN.AUTH.HEADER.AUTH-DOCTOR' | translate }}
                    </a>

                </li>
                <li class="register-btn">
<!--                    <a routerLink="/auth/register" class="btn reg-btn">-->
<!--                        <i class="feather icon-user"></i>{{'ADMIN.BUTTONS.SIGN-UP' | translate }}-->
<!--                    </a> -->
                    <a routerLink="/auth/register" class="btn reg-btn">
                        <i class="feather icon-user"></i>{{'ADMIN.BUTTONS.SIGN-UP' | translate }}
                    </a>
                </li>
                <li class="register-btn">
                    <a routerLink="/auth/login" class="btn btn-primary log-btn">
                        <i class="feather icon-lock"></i>{{ 'ADMIN.BUTTONS.LOGIN' | translate }}
                    </a>
                </li>
                <!--<li>
                    <div class="header-element d-flex align-items-center justify-content-center py-3 px-2 header-country">
                        <div class="dropdown">
                            <button id="dropdown-flag" type="button" class="btn border-0 rounded-circle shadow-none dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                <img src="assets/img/flags/{{currentLanguage}}_flag.jpg" alt="flag-img"  class="flag-img rounded-circle"
                                >
                            </button>

                            <ul class="dropdown-menu min-w-100" aria-labelledby="dropdown-flag">
                                <li>
                                    <div class="dropdown-divider"></div>
                                </li>
                                <li>
                                    <a class="dropdown-item d-flex align-items-center py-1" href="#" (click)="useLanguage('en')">
                                        <div class="me-2 d-flex justify-content-center align-items-center" style="height: 1.6rem; width: 1.5rem;">
                                            <img src="assets/img/flags/en_flag.jpg" alt="flag-img" class=" flag-img-select rounded-circle"
                                            >
                                        </div>
                                        <p class="mb-0" style="font-size: 0.8125rem;">English</p>
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item d-flex align-items-center py-1" href="#" (click)="useLanguage('fr')">
                                        <div class="me-2 d-flex justify-content-center align-items-center" style="height: 1.6rem; width: 1.5rem;">
                                            <img src="assets/img/flags/fr_flag.jpg" alt="flag-img" class=" flag-img-select rounded-circle"
                                            >
                                        </div>
                                        <p class="mb-0" style="font-size: 0.8125rem;">Français</p>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>-->

            </ul>
            <ul class="nav header-navbar-rht" *ngIf="user">
                <!-- User Menu -->
                <li class="nav-item dropdown has-arrow logged-item">
                    <a href="javascript:void(0)" class="dropdown-toggle nav-link" data-bs-toggle="dropdown">
                        <span class="user-img">
                            <img *ngIf="!user?.image" src="assets/img/no-profile-picture.webp" alt="User image" class="w-24 h-24 mr-4 border border-gray-300  rounded-circle" />
                            <img *ngIf="user?.image" [src]="user?.image" alt="User image" class="w-24 h-24 mr-4 border border-gray-300  rounded-circle" />
                        </span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end">
                        <div class="user-header">
                            <div class="avatar avatar-sm">
                                <img *ngIf="!user?.image" src="assets/img/no-profile-picture.webp" alt="User image" class="w-24 h-24 mr-4 border border-gray-300  rounded-circle" />
                                <img *ngIf="user?.image" [src]="user?.image" alt="User image" class="w-24 h-24 mr-4 border border-gray-300  rounded-circle" />
                            </div>
                            <div class="user-text">
                                <h6> {{ user?.firstName }} {{ user?.lastName }} {{ user?.name }}
                                </h6>
                                <p class="text-success mb-0">{{'ADMIN.AUTH.HEADER.AVAILABLE' | translate }}</p>
                            </div>
                        </div>
                        <a *ngIf="dashboardUrl" class="dropdown-item" [routerLink]="[dashboardUrl]">{{'ADMIN.AUTH.HEADER.DASHBOARD' | translate }}</a>
                        <a *ngIf="accountUrl" class="dropdown-item" [routerLink]="[accountUrl]">{{'ADMIN.AUTH.HEADER.ACCOUNT' | translate }}</a>
                        <a class="dropdown-item"  (click)="logout()">{{'ADMIN.BUTTONS.LOG-OUT' | translate }}</a>
                    </div>
                </li>
            </ul>
        </nav>
    </div>
</header>